import React, { useState } from "react";
import { Form } from "react-bootstrap";
// import {useForm} from "react-hook-form";
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FormControl from '@material-ui/core/FormControl';
// import FormLabel from '@material-ui/core/FormLabel';

export default function GenderForm(props) {
    const [value, setValue] = useState('Both');
    let sortGender = props.sortGender;

    const handleChange = (event) => {
        console.log(event.target.value);
        setValue(event.target.value);
        sortGender(event.target.value);
    };


      return (
        <div>

          {/* <div className='bg-secondary rounded align-items-center'> */}
          <Form name="gender" value={value} onChange={handleChange}>
          <fieldset>
            <Form.Group>
              <Form.Label>Gender</Form.Label>
                <Form.Check 
                  type="checkbox"
                  label="Both"
                  name="formHorizontalRadios"
                  value="Both"
                  id="formHorizontalRadios1"
                  // ref={register}  
                  onClick={() => sortGender(value)}
                  defaultChecked
                />
                <Form.Check
                  type="checkbox"
                  label="Male"
                  name="formHorizontalRadios"
                  value="Male"
                  id="formHorizontalRadios2"
                  // ref={register}  
                  onClick={() => sortGender(value)}
                />
                <Form.Check
                  type="checkbox"
                  label="Female"
                  name="formHorizontalRadios"
                  value="Female"
                  id="formHorizontalRadios3"
                  // ref={register}  
                  onClick={() => sortGender(value)}
                />
            </Form.Group>
          </fieldset>
          </Form>
        </div>
      );

  }
  
